import React, { useState, useEffect, useRef } from "react";
import InView from "react-intersection-observer";
import CountUp from "react-countup";
import LazyLoad from 'react-lazyload';
import ImageCurve from "../../images/curve-shape-intro-section.svg";
import ImageThumb1 from "../../images/po-intro-img-1.png";
import ImageThumb2 from "../../images/po-intro-img-2.png";
import ImageThumb3 from "../../images/po-intro-img-3.png";
import Parallax from '../common/utils/animations/parallax';
import { directions } from '../common/utils/animations/animationConstants';
//import AOS from 'aos';
import 'aos/dist/aos.css'

export default function Intro() {
  const [counterTrigger, setCounterTrigger] = useState(false);

  let AOS;

  useEffect(() => {
    const AOS = require("aos");
    AOS.init({
      once: true,
    });
  }, []);

  useEffect(() => {
    if (AOS) {
      AOS.refresh();
    }
  });

  return (
    <InView>
      <div className="cs-intro-section section-gap po-cs-intro-section">
          <div className="container">
            <div className="intro-inner">
              <h3 className="h3">Painful and multi-billion dollar problem </h3>
              <p>More than 10 million people suffer from musculoskeletal (MSK) injuries every year in the USA. Patients have to bear physical, mental, and financial pain due to loss of work and pay. On the other hand, companies also face resource shortages and spend billions on compensating for their employees' injuries and loss of time.</p>

              <p>The top reasons why such injuries happen and take longer to heal are lack of education and patients’ active participation in their recovery. </p>
              <InView as="div" onChange={(inView) => { if (inView) setCounterTrigger(inView); }} className="future-counter-block" threshold={[0.4]}>
              <ul>
                  <li>
                      <h4 className="blue-color">{counterTrigger ? <CountUp start={0} end='7' duration={1.5} delay={0.3} /> : 0}<sub>M</sub></h4>
                      <p>work-related injuries happened in the USA, in 2019, National Safety Council.</p>
                  </li>
                  <li>
                      <h4 className="yellow-color">${counterTrigger ? <CountUp start={0} end='171' duration={1.5} delay={0.3} /> : 0}<sub>B</sub></h4>
                      <p>in direct financial costs to employers resulted from MSK injuries in 2019.</p>
                  </li>
                  <li>
                      <h4 className="lovander-color">{counterTrigger ? <CountUp start={0} end='80' duration={1.5} delay={0.3} /> : 0}<sub>%</sub></h4>
                      <p>of all job-related injuries were musculoskeletal injuries in 2021.</p>
                  </li>
              </ul>
              </InView>
            </div>
          </div>
          <div className="po-intro-image">
            <div className="image-curve">
                <img src={ImageCurve} title="personalized patient experience" alt="personalized patient experience" />
            </div>
            
            <div className="image-thumb">
              <div data-aos="zoom-in"><Parallax classes="po-intro-image1" id="po-intro-image1" direction={directions.TTB} triggers={[1.2, 0.2]} length={50}><LazyLoad offset={500}><img src={ImageThumb1} title="Knee injury" alt="Knee injury" /></LazyLoad></Parallax></div>
              <div data-aos="zoom-in"><Parallax classes="po-intro-image2" id="po-intro-image2" direction={directions.TTB} triggers={[1.2, 0.2]} length={50}><LazyLoad offset={500}><img src={ImageThumb2} title="Injured patient" alt="Injured patient" /></LazyLoad></Parallax></div>
              <div data-aos="zoom-in"><Parallax classes="po-intro-image3" id="po-intro-image3" direction={directions.TTB} triggers={[1.2, 0.2]} length={50}><LazyLoad offset={500}><img src={ImageThumb3} title="Physicians " alt="Physicians " /></LazyLoad></Parallax></div>
            </div>
          </div>
      </div>
    </InView>
  );
}